//frontend/src/component/BlogTeasers.jsx
export default function BlogTeasers({ posts=[] }){
  if (!posts.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 mt-10">
      <h2 className="text-2xl font-semibold mb-3">Блог</h2>
      <div className="grid md:grid-cols-4 gap-3">
        {posts.slice(0,4).map(p=>(
          <a key={p.id} href={p.href} className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md">
            <img src={p.image} alt={p.title} className="w-full h-36 object-cover" loading="lazy"/>
            <div className="p-3 text-sm font-medium line-clamp-2">{p.title}</div>
          </a>
        ))}
      </div>
    </section>
  );
}
